<template>
<div class="bottom-sheets">
	<v-bottom-sheet :value="$store.state.loading.error" persistent>
		<v-sheet v-if="$store.state.loading.error" class="text-center" height="200px">
			<h2 class="pt-4 secondary--text">An Error Occurred</h2>
			<div class="py-2">{{$store.state.loading.error.message || $store.state.loading.error}}</div>
			<v-btn
				class="mt-2"
				text
				color="primary"
				:href="reportURL"
			>send error report</v-btn>
			<div>
			<v-btn
				class="mt-2"
				text
				color="error"
				outlined
				@click="$store.dispatch('loading/RESET_ERROR', {root:true})"
			>close</v-btn>
			</div>
		</v-sheet>
	</v-bottom-sheet>
<!-- 	<v-bottom-sheet :value="success" persistent>
		<v-sheet class="text-center" height="200px">
			<v-btn
				class="mt-6"
				text
				color="success"
				@click="closeSuccess"
			>close</v-btn>
			<h2>Success!</h2>
			<div class="py-3">Here's the result:</div>
			<div class="py-3">{{$store.state.loading.result}}</div>
		</v-sheet>
	</v-bottom-sheet> -->
	<v-snackbar
      v-model="success"
      color="success"
      :timeout="20000"
	>
      <b>Success:</b> {{$store.state.loading.result}}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="closeSuccess"
        >
          Close
        </v-btn>
      </template>
	</v-snackbar>
	<v-dialog v-model="loading" persistent width="300">
		<v-card color="secondary" dark>
			<v-card-text>
				<ssc-loader />
				<p class="pt-3 text-center">{{$store.state.loading.loadingMessage || "Loading..."}}</p>
			</v-card-text>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import LoadingState from "../consts/LoadingState"
export default {
	computed: {
		success: {
			get() {
				return this.$store.state.loading.loading == LoadingState.SUCCESS
			},
			set(val) {
				if (val == false)
					this.$store.dispatch("loading/"+LoadingState.ACTION_END_LOADING)
			}
		},
		loading() {
			return this.$store.state.loading.loading == LoadingState.LOADING
		},
		reportURL() {
			let url = `mailto:support@orixe.eu?subject=%5BOrixe%20Error%20Reporting%5D%20${this.$store.getters["user/getUser"].clientName}&body=If%20you%20wish%20to%20add%20a%20message%2C%20please%20write%20it%20here%3A%0D%0A%0D%0A%0D%0A%0D%0A%0D%0A%0D%0A-------------%0D%0APlease%20do%20not%20change%20the%20information%20below%20this%20line.%0D%0A%0D%0AError%20Code%3A%20${this.$store.state.loading.error.code}%0D%0AIncident%20ID%3A%20${this.$store.state.loading.error.incidentID}%0D%0ADate%20%26%20Time%3A%20${new Date()}%0D%0AURL%20of%20Error%3A%20${window.location}%0D%0A%0D%0AOrixe%20Username%3A%20${this.$store.getters["user/getUser"].username}%0D%0A`
			return url
		}
	},
	methods: {
		closeSuccess() {
			this.$store.dispatch("loading/"+LoadingState.ACTION_END_LOADING)
		}
	}
}
</script>